// extracted by mini-css-extract-plugin
export default {"highlight":"TypeaheadUtils_highlight__8tA+J"};